import { useRouter } from "next/router";
import { useTranslationI18 } from "../../../../../services/hooks/useTranslationI18";
import { PagesEnum } from "../../../../../utils/enums";
import { getPageLink } from "../../../../../utils/help/navigation/navigation";
import { LoyaltyPointsBalance } from "../../LoyaltyPointsBalance/LoyaltyPointsBalance";
import { LoyaltyPointsExpiryBanner } from "../../LoyaltyPointsExpiryBanner/LoyaltyPointsExpiryBanner";
import { LoyaltyPointsProgressBar } from "../../LoyaltyPointsProgressBar/LoyaltyPointsProgressBar";
import styles from "./LoyaltyTierRewardsSummary.module.scss";

interface LoyaltyTierRewardsSummaryProps {
  showMilestones: boolean;
  /** Signed-in members see their balance; guests get the sign-in prompt. */
  isSignedIn: boolean;
  tierColor?: string;
  onViewAll: () => void;
}

export const LoyaltyTierRewardsSummary = ({
  showMilestones,
  isSignedIn,
  tierColor,
  onViewAll,
}: LoyaltyTierRewardsSummaryProps) => {
  const { t } = useTranslationI18();
  const router = useRouter();

  return (
    <div className={styles.tier_rewards}>
      <div
        className={`${styles.rewards_heading} ${
          isSignedIn ? "" : styles.rewards_heading_captioned
        }`}
      >
        <h1>
          {isSignedIn
            ? t("pointing-system:rewards")
            : t("pointing-system:total-balance").replace(/:$/, "")}
        </h1>
        <button
          type="button"
          // Pushing href with as lets Next reuse what it prefetched instead of
          // resolving the route from the URL again.
          onClick={() => {
            const link = getPageLink(router, PagesEnum.OurPolicies);

            router.push(link.href, link.as);
          }}
        >
          {t("pointing-system:how-it-works")}
        </button>
      </div>

      {isSignedIn ? (
        <div className={styles.points_row}>
          <LoyaltyPointsBalance />
          {showMilestones && (
            <button type="button" onClick={onViewAll}>
              {t("pointing-system:view-all")}
            </button>
          )}
        </div>
      ) : (
        <p className={styles.signed_out_message}>
          {t("pointing-system:check-your-total")}
        </p>
      )}

      <LoyaltyPointsExpiryBanner />

      {showMilestones && (
        <LoyaltyPointsProgressBar tierColor={tierColor} tierVariant />
      )}
    </div>
  );
};
